import { gql } from "@apollo/client";


export const GET_ALL_JUSTIFICACION_CONDICIONAL = gql`
    query getJustificacionCondicional($tipoJustificacion: String!, 
                                          $idEvaluacion: Int!,
                                          $idOrdenPedido: Int!,
                                          $idEstadoComercial: Int!,
                                          $idEstadoMedico: Int!,
                                          $idEstadoBUM: Int!){
        allJustificacionCondicional(input: {
                        tipoJustificacion: $tipoJustificacion,
                        idEvaluacion: $idEvaluacion,
                        idOrdenPedido: $idOrdenPedido,
                        idEstadoComercial: $idEstadoComercial,
                        idEstadoMedico: $idEstadoMedico,
                        idEstadoBUM: $idEstadoBUM                        
                    })
        {
                success,
                error,
                valorEsperado {         
                    descDelegacion,
                    idJustificacion,
                    tipoJustificacion,
                    idEvaluacion,
                    idOrdenPedido,
                    diasCondiContrato,
                    diasMaxFactCliente,
                    estadoPEnvio,
                    justificadoMedico,
                    justificadoComercial,
                    obsComercial,
                    obsMedico,
                    idPaciente,
                    paciente,
                    cobertura,
                    planCuidado,
                    descEstadoComercial,
                    descEstadoMedico,
                    descEstadoBUM,
                    fechaEntrega,
                    idUsuarioMedico,
                    idUsuarioComercial,
                    fechaMedico,
                    fechaComercial,
                    fechaAlta,
                    contratosCO,
                    obsBUM,
                    idUsuarioBUM,
                    fechaBUM,
                    justificadoBUM,,
                    codigoEstadoComercial,
                    codigoEstadoMedico,
                    codigoEstadoBUM

                }
        }
 }
`;